<!-- フッタ -->
<template>
  <footer id="footer1">
    <div class="com_inner1 clearfix">
      <p class="copyright1">&copy; 2025 Kaunet</p>
    </div>
  </footer>
</template>
